import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { withTranslation } from 'react-i18next';
import { LoaderContext } from '../../../App';
import { CategoryList } from '../../../core/constants/common';
import AssignSubscriptionService from '../../../core/service/AssignSubscriptionService';
import CompanyService from '../../../core/service/CompanyService';
import GraphConfigList from '../DashboardGraphConfig/GraphConfigList';

const AssignGraphConfig = ({ t }) => {

	const { loaderDisplay, setLoaderDisplay } = useContext(LoaderContext);

	const [isLoading, setIsLoading] = useState(false);
	const [companies, setCompanies] = useState([]);
	const [companyId, setCompanyId] = useState(0);
	const [standards, setStandards] = useState([]);
	const [standardName, setStandardName] = useState('');
	const [categoryName, setCategoryName] = useState('');

	const filterBy = () => true;

	useEffect(() => {
		if (companyId <= 0) return;

		getStandards(companyId);
	}, [companyId]);

	const getStandards = (cId) => {
		CompanyService.getCompanySubscriptions(cId, 'S')
		.then((response) => {
			if (response.status !== 200) return;

			setStandards([...response.data.regulations]);
			setStandardName('');
			setCategoryName('');
		})
		.catch((error) => {});
	};

	const handleSearch = (query) => {
		setIsLoading(true);
		AssignSubscriptionService.getCompanyList(query)
			.then(res => {
				setIsLoading(false);
				if (res.status !== 200) return;

				const options = res.data?.map((i) => ({
					id: i.companyId,
					legalName: i.legalName,
				}));
				setCompanies(options);
			})
			.catch((error) => {
			});
	};

	return (
		<div className="AssignSubscription">
			<div className="List_header">
				<h5 className="MH">{t("AssignGraphConfig.label")}</h5>
			</div>
			<div>
				<Form>
					<div className="row m-0 align-items-center">
						<div className="col-lg-4 p-0">
							<div className="p-2">
								<label className="mb-1">{t("company.label")} <span className='text-red'>*</span></label>
								<AsyncTypeahead
									filterBy={filterBy}
									id="company"
									isLoading={isLoading}
									labelKey="legalName"
									minLength={2}
									onSearch={handleSearch}
									onChange={(selected) => {
										if (selected[0]) {
											setCompanyId(selected[0].id)
										}
									}}
									options={companies}
									placeholder={t("Search.label")}
									renderMenuItemChildren={(option, props) => (
										<Fragment>
											<span>{option.legalName}</span>
										</Fragment>
									)}
								/>
							</div>
						</div>
						<div className="col-lg-4 p-0">
							<div className="p-2">
								<label htmlFor="esgFilter">{t("Standard.label")}</label>
								<select id="esgFilter"
									className="form-select"
									onChange={(e) => setStandardName(e.target.value)}>
									<option value='' key=''>{t('Select.label')}</option>
									{
										standards.map(c => {
											return <option value={c.name} key={c.id}>{c.name}</option>
										})
									}
								</select>
							</div>							
						</div>
						<div className="col-lg-4 p-0">
							<div className="p-2">
								<label htmlFor="esgFilter">{t("Category.label")}</label>
								<select id="esgFilter"
									className="form-select"
									onChange={(e) => setCategoryName(e.target.value)}>
									<option value='' key=''>{t('Select.label')}</option>
									{
										CategoryList({ t }).map(c => {
											return <option value={c.value} key={c.id}>{c.text}</option>
										})
									}
								</select>
							</div>							
						</div>
						<div className='col-lg-12'>
							<GraphConfigList companyId={companyId} 
								standardName={standardName}
								categoryName={categoryName}
								forAssignment={true}
								/>
						</div>
					</div>
				</Form>
			</div>
		</div>
	)
};

export default withTranslation()(AssignGraphConfig);
